export const privilege = [
  {
    name: 'Index',
    url: '/privilege/',
    icon: 'icon-home'
  },
  {
    name: 'Create Privilege',
    url: '/privilege/create',
    icon: 'icon-plus'
  }
];
